import { render, staticRenderFns } from "./invite-more.vue?vue&type=template&id=5a55ddac&scoped=true&"
import script from "./invite-more.vue?vue&type=script&lang=ts&"
export * from "./invite-more.vue?vue&type=script&lang=ts&"
import style0 from "./invite-more.vue?vue&type=style&index=0&id=5a55ddac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55ddac",
  null
  
)

export default component.exports